// extracted by mini-css-extract-plugin
export default {"widget":"styles_widget__meu-s","icon":"styles_icon__a3TaL","arrow":"styles_arrow__giqJv"};